import { ChevronLeftSharp, ChevronRightSharp } from '@mui/icons-material';
import { AppBar, Container, Grid, Tab, Tabs } from '@mui/material';
import MKPagination from 'components/MKPagination';
import eventsData from 'csdd_data/csddEvents';
import TransparentBlogCard from 'examples/Cards/BlogCards/TransparentBlogCard';
import { useState } from 'react';

import slug from 'slug';

import upcomingEventsData from 'csdd_data/csddUpcomingEvents';
import MKTypography from 'components/MKTypography';

const EventsCompo = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabType = (event, newValue) => setActiveTab(newValue);
  return (
    <Container>
      <Container id='start' sx={{ py: 5 }}>
        <Grid container item justifyContent='center' xs={12} lg={4} mx='auto'>
          <AppBar position='static'>
            <Tabs value={activeTab} onChange={handleTabType}>
              <Tab label='All Events' />
              <Tab label='Upcoming Events' />
            </Tabs>
          </AppBar>
        </Grid>
      </Container>
      <Container sx={{ display: activeTab === 0 ? 'block' : 'none' }}>
        {eventsData.length === 0 ? (
          <MKTypography textAlign='center' color='warning'>
            There are no events at the moment.
          </MKTypography>
        ) : (
          <>
            <Grid container spacing={3}>
              {eventsData.map((article) => {
                return (
                  <Grid item xs={12} sm={6} lg={4} key={article.route}>
                    <TransparentBlogCard
                      image={article.headerImage}
                      title={article.title}
                      description={article.description}
                      action={{
                        type: 'internal',
                        route: `/news/${slug(article.title)}`,
                        color: 'error',
                        label: 'read more',
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Container sx={{ mt: 5 }}>
              <MKPagination placement='center'>
                <MKPagination item>
                  <ChevronLeftSharp color='warning' />
                </MKPagination>
                <MKPagination item active>
                  1
                </MKPagination>
                <MKPagination item>2</MKPagination>
                <MKPagination item>3</MKPagination>
                <MKPagination item>
                  <ChevronRightSharp color='warning' />
                </MKPagination>
              </MKPagination>
            </Container>
          </>
        )}
      </Container>

      <Container sx={{ display: activeTab === 1 ? 'block' : 'none' }}>
        {upcomingEventsData.length === 0 ? (
          <MKTypography textAlign='center' color='warning'>
            There are no upcoming events at the moment.
          </MKTypography>
        ) : (
          <>
            <Grid container spacing={3}>
              {upcomingEventsData.map((article) => {
                return (
                  <Grid item xs={12} sm={6} lg={4} key={article.route}>
                    <TransparentBlogCard
                      image={article.headerImage}
                      title={article.title}
                      description={article.description}
                      action={{
                        type: 'internal',
                        route: `/news/${slug(article.title)}`,
                        color: 'error',
                        label: 'read more',
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Container sx={{ mt: 5 }}>
              <MKPagination placement='center'>
                <MKPagination item>
                  <ChevronLeftSharp color='warning' />
                </MKPagination>
                <MKPagination item active>
                  1
                </MKPagination>
                <MKPagination item>2</MKPagination>
                <MKPagination item>3</MKPagination>
                <MKPagination item>
                  <ChevronRightSharp color='warning' />
                </MKPagination>
              </MKPagination>
            </Container>
          </>
        )}
      </Container>
    </Container>
  );
};
export default EventsCompo;
